<template>
  <v-container fluid class="dispatch-container">
    <template #shipmentCard="{ shipment }">
      <v-card-text class="elevation-5">
        <v-btn text @click="linkClick(shipment)"> {{ shipment.shipment_id }} – {{ shipment.customer_name }} </v-btn>

        <div class="text-sm">
          Pickup:
          <b>{{ shipment.service_date || shipment.pickup_date_range }}</b> | Delivery:
          <b>{{ shipment.delivery_date_range }}</b
          ><br />

          <b>
            <img
              style="width: 16px; height:16px"
              :src="`https://hatscripts.github.io/circle-flags/flags/${shipment.origin_country}.svg`"
            />
            {{ shipment.origin_address }} →
            <img
              style="width: 16px; height:16px"
              :src="`https://hatscripts.github.io/circle-flags/flags/${shipment.destination_country}.svg`"
            />
            {{ shipment.destination_address }} </b
          ><br />

          Volume: {{ (shipment.volume * 0.0283168).toFixed(2) }} CM<br />

          <div v-if="shipment.closestPort">Closest Ports: {{ shipment.closestPort }}</div>
        </div>
      </v-card-text>
    </template>

    <!-- Date filters + buttons -->
    <v-toolbar flat>
      <v-date-field label="Start Date" v-model="startDate" dense outlined></v-date-field>
      <v-date-field label="End Date" v-model="endDate" dense outlined></v-date-field>
      <v-dialog max-width="80%" v-model="shipDialog">
        <v-card>
          <v-card-text class="ma-2">
            <!-- <v-form-card
              v-if="shipDialog"
              :dObject="dObject"
              v-bind="schema['v-bind']"
              ref="form"
              :panels="true"
              :key="formKey"
              :noCache="noCache"
              :hasParent="hasParent"
            ></v-form-card> -->
            <v-form-component
              ref="formComponent"
              :key="formKey"
              :model="currentModel"
              :vModel="currentModel"
              :schema="shipSchema"
              :noEditForm="true"
              :data_object="{
                schema: schema,
                objectName: 'international_shipment'
              }"
            ></v-form-component>
            <v-card-actions class=" justify-center">
              <!-- <v-spacer></v-spacer> -->
              <v-btn color="primary" small @click="saveShip()">Update</v-btn>
            </v-card-actions>
          </v-card-text>
          <!-- currentModel {{ currentModel }} -->
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" width="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text color="red lighten-2" dark v-bind="attrs" v-on="on">
            Advanced Filter
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Advanced Filter
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- POL Country -->
                <v-combobox
                  v-model="filters.pol_country"
                  :items="countryList"
                  item-text="name"
                  item-value="code"
                  label="POL Country"
                  clearable
                  outlined
                  dense
                ></v-combobox>

                <v-combobox
                  v-model="filters.pod_country"
                  :items="countryList"
                  item-text="name"
                  item-value="code"
                  label="POD Country"
                  clearable
                  outlined
                  dense
                ></v-combobox>

                <!-- ETA Date Range -->
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="etaMenu"
                    v-model="etaMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filters.eta_range"
                        label="ETA Range"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.eta_range"
                      range
                      scrollable
                      @change="etaMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- ETD Date Range -->
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="etdMenu"
                    v-model="etdMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filters.etd_range"
                        label="ETD Range"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.etd_range"
                      range
                      scrollable
                      @change="etdMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Cut-Off Date -->
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="cutOffMenu"
                    v-model="cutOffMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filters.cut_off_range"
                        label="Cut-off Date Range"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.cut_off_range"
                      range
                      scrollable
                      @change="cutOffMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="applyFilter">Apply</v-btn>
            <v-btn color="secondary" text @click="resetFilter">Reset</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer />
      <v-btn @click="fetchShipments()" text><v-icon class="ma-2">mdi-reload</v-icon>Refresh</v-btn>
    </v-toolbar>

    <v-row v-if="!loading">
      <!-- Ships -->
      <v-col cols="12" md="6">
        <h2 class="font-weight-bold mb-2">Ships</h2>
        <!-- <v-btn @click="toggleShips" color="grey lighten-1" dark>
          {{ showAllShips ? "Filter Ships" : "Show All Ships" }}
        </v-btn> -->
        <v-btn
          text
          @click="
            openShip({
              _id: '_new',
              shipment_name: '(New International Shipment)'
            })
          "
        >
          <v-icon left small color="blue darken-2">mdi-ferry</v-icon>
          Create New
        </v-btn>
        <v-container
          @dragover.prevent="handleWindowDragOver"
          fluid
          class="pa-0"
          style="max-height: 60vh; overflow-y: auto;"
        >
          <!-- Ships -->

          <v-card
            v-for="ship in filteredShips"
            :key="ship._id"
            class="mb-4"
            outlined
            :class="getColorClass(ship.port_of_discharge)"
          >
            <v-card-title class="font-weight-bold">
              <v-btn text @click="openShip(ship)">
                <v-icon left small color="blue darken-2">mdi-ferry</v-icon>
                {{ ship.shipment_name }}
              </v-btn>
            </v-card-title>
            <v-card-subtitle>
              POL: {{ ship.port_of_loading }}
              <img
                style="width: 16px; height:16px"
                :src="`https://hatscripts.github.io/circle-flags/flags/${ship.pol_country}.svg`"
              />
              → POD {{ ship.port_of_discharge }}
              <img
                style="width: 16px; height:16px"
                :src="`https://hatscripts.github.io/circle-flags/flags/${ship.pod_country}.svg`"
              />
              <br />
              Cutoff: {{ ship.cut_off_date }} | ETD: {{ ship.etd }} | ETA:{{ ship.eta }}<br />

              <!-- <v-icon>mdi-train-car-container</v-icon>  -->
            </v-card-subtitle>

            <v-card-text>
              <div v-if="ship.container_size">
                <v-progress-linear
                  :value="getPercent(ship)"
                  height="32"
                  color="blue darken-2"
                  class="container-progress"
                  rounded
                >
                  <template v-slot:default>
                    <span class="white--text font-weight-bold">
                      Container Size: {{ ship.container_size }} {{ Math.ceil(getPercent(ship)) }}%
                      {{ getUsedCapacity(ship) }} / {{ getCapacity(ship) }} CBM
                    </span>
                  </template>
                </v-progress-linear>

                <!-- <div class="caption mt-1">
                  {{ getUsedCapacity(ship) }} / {{ getCapacity(ship) }}
                </div> -->
              </div>
              <!-- Drop zone for shipments -->
              <div
                ref="scrollContainer"
                :key="ship_key"
                class="drop-zone mt-2 pa-2 lighten-4"
                @drop.stop="handleDrop($event, 'ship', ship)"
                @dragover.prevent="handleDragOver"
              >
                <v-card
                  v-for="shipment in fullShipments(ship) || []"
                  :key="shipment._id"
                  outlined
                  class="mb-2"
                  :class="getColorClass(shipment.closestPort)"
                  draggable="true"
                  @dragstart="handleDragStart($event, shipment, 'ship', ship)"
                >
                  <shipment-block :shipment="shipment" @link-click="linkClick" />
                  <!-- <v-card-text class=" elevation-5">
                    <v-btn text @click="linkClick(shipment)">{{ shipment.shipment_id }} –
                      {{ shipment.customer_name }}</v-btn>

                    <div class="text-sm">
                      Pickup: <b>{{ shipment.service_date || shipment.pickup_date_range }} </b>| Delivery:
                      <b>{{ shipment.delivery_date_range }} </b><br />
                      <b><img style="width: 16px; height:16px"
                          :src="`https://hatscripts.github.io/circle-flags/flags/${shipment.origin_country}.svg`">
                        {{ shipment.origin_address }} → <img style="width: 16px; height:16px"
                          :src="`https://hatscripts.github.io/circle-flags/flags/${shipment.destination_country}.svg`">
                        {{
                          shipment.destination_address }} </b> <br />
                      Volume: {{ (shipment.volume * 0.0283168).toFixed(2) }} CM <br />
                      <div v-if="shipment.closestPort">Closest Ports: {{ shipment.closestPort }}</div>
                    </div>
                  </v-card-text> -->
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </v-container>
      </v-col>

      <!-- Unassigned Shipments -->
      <v-col cols="12" md="6">
        <h2 class="font-weight-bold mb-2">
          Unassigned Shipments
        </h2>
        <!-- <v-btn @click="toggleShipments" color="grey lighten-1" dark>
          {{ showAllShipments ? "Filter Shipments" : "Show All Shipments" }}
        </v-btn> -->
        <v-container
          :key="shipment_key"
          fluid
          class="pa-0 drop-zone mt-2 pa-2 lighten-4"
          style="max-height: 60vh; overflow-y: auto;"
          @drop="handleDrop($event, 'unassigned')"
          @dragover.prevent
        >
          <v-card
            v-for="shipment in filteredShipments"
            :key="shipment._id"
            class="mb-2"
            outlined
            draggable="true"
            @dragstart="handleDragStart($event, shipment, 'unassigned')"
            :class="getColorClass(shipment.closestPort)"
          >
            <shipment-block :shipment="shipment" @link-click="linkClick" />
            <!-- <v-card-text>
              <v-btn text @click="linkClick(shipment)">{{ shipment.shipment_id }} –
                {{ shipment.customer_name }}</v-btn>
              <div class="text-sm">
                Pickup: <b>{{ shipment.service_date || shipment.pickup_date_range }} </b>| Delivery:
                <b>{{ shipment.delivery_date_range }} </b><br />
                <b><img style="width: 16px; height:16px"
                    :src="`https://hatscripts.github.io/circle-flags/flags/${shipment.origin_country}.svg`">
                  {{ shipment.origin_address }} → <img style="width: 16px; height:16px"
                    :src="`https://hatscripts.github.io/circle-flags/flags/${shipment.destination_country}.svg`">
                  {{
                    shipment.destination_address }} </b> <br />

                Volume: {{ (shipment.volume * 0.0283168).toFixed(2) }} CM <br />
                <div v-if="shipment.closestPort">Closest Ports: {{ shipment.closestPort }}</div>

              </div>
            </v-card-text> -->
          </v-card>
        </v-container>
      </v-col>
    </v-row>
    <div v-else>
      <div class="mt-2 grey--text">Loading data...</div>
      <v-skeleton-loader
        class="mx-auto"
        :tile="true"
        max-width="90%"
        type="heading,table-tbody"
        loading-text="Loading data..."
      ></v-skeleton-loader>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { startOfMonth, endOfMonth, parse } from "date-fns";

export default {
  name: "InternationalShipmentDispatch",
  components: {
    VDateField: () => import("../components/DateField.vue"),
    ShipmentBlock: () => import("../components/UI/ShipmentBlock.vue"),
    VFormComponent: () => import("../components/FormComponent.vue"),
    VFormCard: () => import("../components/FormCard.vue")
  },
  data() {
    return {
      startDate: startOfMonth(new Date())
        .toISOString()
        .substr(0, 10),
      endDate: endOfMonth(new Date())
        .toISOString()
        .substr(0, 10),
      showAllShips: false,
      showAllShipments: false,
      ships: [],
      shipments: [],
      draggingShipment: null,
      draggingFrom: null,
      draggingShip: null,
      portList: [],
      dObject: null,
      objectName: "international_shipment",
      ship_key: 0,
      shipment_key: 0,
      loading: false,
      etaMenu: false,
      etdMenu: false,
      cutOffMenu: false,
      schema: null,
      shipSchema: null,
      filters: {
        pol_country: null,
        pod_country: null,
        eta_range: null,
        etd_range: null,
        cut_off_range: null
      },
      countryList: [],
      dialog: false,
      shipDialog: false,
      currentMode: null,
      currentSchema: null,
      formKey: 0
    };
  },
  mounted() {
    this.fetchShipments();
  },
  computed: {
    shipmentsWithPort() {
      // collect all assigned shipment IDs
      const assignedIds = new Set(this.ships.flatMap(s => (s.shipments || []).map(r => String(r.shipment_id))));

      return this.shipments
        .filter(s => !assignedIds.has(String(s.shipment_id)))
        .map(s => ({
          ...s,
          // closestPort: s.closest_port,
          serviceDateParsed: s.service_date ? parse(s.service_date + " 2025", "MMM dd yyyy", new Date()) : null
        }));
    },
    filteredShipments() {
      if (this.showAllShipments) return this.shipmentsWithPort;
      return this.shipmentsWithPort
        .filter(
          s =>
            !s.serviceDateParsed ||
            (s.serviceDateParsed >= new Date(this.startDate) && s.serviceDateParsed <= new Date(this.endDate))
        )
        .filter((s, index, self) => index === self.findIndex(t => String(t.shipment_id) === String(s.shipment_id)));
    },
    sortedShipments() {
      return [...this.filteredShipments].sort((a, b) =>
        a.closestPort && b.closestPort ? a.closestPort.localeCompare(b.closestPort) : 0
      );
    },
    // filteredShips() {
    //   if (this.showAllShips) return this.ships;
    //   return this.ships.filter((ship) => {
    //     const etdDate = parse(ship.cut_off_date + " 2025", "MMM dd yyyy", new Date());
    //     return (!ship.cut_off_date ||
    //       etdDate >= new Date(this.startDate) &&
    //       etdDate <= new Date(this.endDate)
    //     );
    //   });
    // },

    filteredShips() {
      var that = this;
      return this.ships.filter(ship => {
        // --- POL Country ---
        if (
          this.filters.pol_country &&
          (ship.pol_country || "").substring(0, 2).toLowerCase() !==
            this.filters.pol_country?.code?.substring(0, 2).toLowerCase()
        ) {
          return false;
        }

        // --- POD Country ---
        if (
          that.filters.pod_country &&
          (ship.pod_country || "").substring(0, 2).toLowerCase() !==
            that.filters.pod_country?.code?.substring(0, 2).toLowerCase()
        ) {
          return false;
        }

        // --- ETA Range ---
        if (this.filters.eta_range && this.filters.eta_range.length === 2) {
          const [start, end] = this.filters.eta_range;
          const eta = ship.eta ? new Date(ship.eta) : null;
          if (!eta || eta < new Date(start) || eta > new Date(end)) {
            return false;
          }
        }

        // --- ETD Range ---
        if (this.filters.etd_range && this.filters.etd_range.length === 2) {
          const [start, end] = this.filters.etd_range;
          const etd = ship.etd ? new Date(ship.etd) : null;
          if (!etd || etd < new Date(start) || etd > new Date(end)) {
            return false;
          }
        }

        // --- Cut-off Range ---
        if (this.filters.cut_off_range && this.filters.cut_off_range.length === 2) {
          const [start, end] = this.filters.cut_off_range;
          const cutoff = ship.cut_off_date ? new Date(ship.cut_off_date) : null;
          if (!cutoff || cutoff < new Date(start) || cutoff > new Date(end)) {
            return false;
          }
        }

        return true;
      });
    }
  },
  methods: {
    // handleWindowDragOver(e) {
    //   const scrollZone = 80; // px from edge before scroll
    //   const scrollSpeed = 25; // px per tick
    //   const viewportHeight = e.currentTarget.clientHeight;
    //   // console.log(e.currentTarget)
    //   // console.log(e.clientY)
    // //  e.currentTarget.scrollBy()
    //  console.log(e.target.clientTop)

    // },

    saveShip() {
      this.shipDialog = 0;
      var that = this;

      var data = {
        metadata: {
          object_name: this.objectName
        },
        model: this.currentModel[this.objectName]
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(function(response) {
          //
        });
    },
    handleWindowDragOver(e) {
      const container = e.currentTarget; // the v-container with overflow-y:auto
      const rect = container.getBoundingClientRect();
      const scrollZone = 60; // px from top/bottom to trigger scroll
      const scrollSpeed = 20; // px per event

      if (e.clientY < rect.top + scrollZone) {
        container.scrollTop -= scrollSpeed;
      } else if (e.clientY > rect.bottom - scrollZone) {
        container.scrollTop += scrollSpeed;
      }
    },
    handleDragOver(e) {
      // const container = this.$refs.scrollContainer;
      const container = e.currentTarget;
      if (!container) return;

      const rect = container.getBoundingClientRect();
      const scrollZone = 60; // px from top/bottom to trigger scroll
      const scrollSpeed = 15; // px per event

      if (e.clientY < rect.top + scrollZone) {
        container.scrollTop -= scrollSpeed;
      } else if (e.clientY > rect.bottom - scrollZone) {
        container.scrollTop += scrollSpeed;
      }
    },
    updateAssigment(s) {
      var data = {
        metadata: {
          object_name: "shipment"
        },

        model: {
          _id: this.draggingShipment.sid
        }
      };
      if (s) {
        data.model.shipment_info = {
          shipment_name: {
            _id: s._id,
            name: s.shipment_name
          }
        };
      } else {
        data.model.shipment_info = null;
      }

      this.axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
        });
    },
    updateShip(s) {
      var data = {
        metadata: {
          object_name: "international_shipment"
        },

        model: {
          _id: s._id,
          measurement_cm: s.measurement_cm,
          measurement_cf: s.measurement_cf,
          gross_weight_kg: s.gross_weight_kg,
          gross_weight_lb: s.gross_weight_lb
        }
      };

      this.axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
        });
    },
    fullShipments(s) {
      var that = this;
      // this.ships.forEach((s) => {
      var acc = [];
      if (Array.isArray(s.shipments) && s.shipments.length) {
        s.shipments.forEach(r => {
          const match = that.shipments.find(i => String(i.shipment_id) === String(r.shipment_id));
          if (match) {
            acc.push(match);
          }
        });
        // s.shipments = acc
        return acc;
        // s.shipments = s.shipments.reduce((acc, r) => {
        //   const match = this.shipments.find(i => String(i.sid) === String(r._id))
        //   if (match) {
        //     acc.push(match)
        //   }
        //   return acc
        // }, [])
        // return s.shipments
      }
      // })
      return acc;
    },
    linkClick: function(item) {
      if (!item.customer_name) {
        item.customer_name = item.first_name + " " + item.last_name;
      }
      if (item.event) {
        item.shipment_id = item.event.shipment_id;
        item.customer_name = item.event.name.replace(item.shipment_id, "").trim();
      }
      this.$root.addResentTab(item);
    },
    openShip(ship) {
      this.currentModel = {
        international_shipment: ship
      };
      // this.dObject = {};
      // this.dObject.schema = this.schema;

      // this.dObject.objectName = this.objectName;
      // this.dObject.parentModel = this.formModel;
      // this.dObject.model = this.currentModel[this.objectName];
      this.shipDialog = true;
    },
    // fetchShips() {
    //   const data_object = {
    //     object_name: "international_shipment",
    //     qry: {},
    //     show_all: true,
    //   };
    //   axios
    //     .post(this.serverURL + "/get_data", data_object, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.data && response.data.model) {
    //         this.ships = response.data.model;
    //       }
    //     })
    //     .catch((err) => console.error("Error fetching ships", err));
    // },
    applyFilter() {
      // Here you filter this.ships according to `this.filters`
      this.dialog = false;
      console.log("Applied filters", this.filters);
    },
    resetFilter() {
      this.filters = {
        pol_country: null,
        pod_country: null,
        eta_range: null,
        etd_range: null,
        cut_off_range: null
      };
    },
    fetchShipments() {
      var that = this;
      this.loading = true;
      const data_object = {
        object_name: "v_shipments",
        // schema_name: "v_shipments",
        qry: { "shipment_detail.move_type": "international" },
        additional_structure: [
          {
            obj_name: "international_shipment"
          }
        ],
        additional_data: [
          {
            obj_name: "v_international_shipments",
            schema_name: "international_shipment"
          },
          { obj_name: "port_list", db_name: "admin" }
        ]
        // add_function: "get_closest_port"
      };
      axios
        .post(this.serverURL + "/get_data", data_object, {
          withCredentials: true
        })
        .then(response => {
          this.loading = false;
          if (response.data && response.data.model) {
            this.shipments = response.data.model;
            this.shipments.forEach(s => {
              if (s.shipment_info) {
                s.closestPort = `${s.shipment_info.origin_closest_port?.name} → ${s.shipment_info.destination_closest_port?.name}`;
                s.type_of_shipment = s.shipment_info.type_of_shipment;
                s.status = s.shipment_info.status;
              }
              s.origin_address = s.origin?.text?.replaceAll("<br/>", ", ");

              s.destination_address = s.destination?.text?.replaceAll("<br/>", ", ");
              s.origin_country = s.origin?.countryCode?.substring(0, 2)?.toLowerCase();
              s.destination_country = s.destination?.countryCode?.substring(0, 2)?.toLowerCase();
              // s.origin = s.stops.find(t => {
              //   return t.value == "pickup"
              // })?.full_address

              // s.destination = s.stops.find(t => {
              //   return t.value == "dropoff"
              // })?.full_address
            });
            // this.ships = response.data.additional_model.v_international_shipments;
            this.portList = response.data.additional_model.port_list;
            // build lookup for faster matching
            console.log(
              "FR ports:",
              that.portList.filter(p => p.country_code === "FR")
            );
            const portMap = {};
            this.portList.forEach(port => {
              portMap[port.code] = port.country_code?.substring(0, 2)?.toLowerCase();
            });

            // enrich ships
            this.ships = response.data.additional_model.v_international_shipments.map(ship => {
              return {
                ...ship,
                pol_country: portMap[ship.port_of_loading] || null,
                pod_country: portMap[ship.port_of_discharge] || null
              };
            });
            // console.log("ships", this.ships);
            this.schema = response.data.additional_structure.international_shipment;
            this.shipSchema = { international_shipment: this.schema };

            const countries = {};

            that.portList.forEach(p => {
              if (p.country_code == "FR") {
                console.log("found France");
              }
              const code = (p.country_code || "").toUpperCase();
              const name = p.country && p.country.trim() !== "" ? p.country : code;

              // Keep the first valid name we see
              if (!countries[code]) {
                countries[code] = name;
              }
            });

            this.countryList = Object.keys(countries)
              .map(code => ({ code, name: countries[code] }))
              .sort((a, b) => a.name.localeCompare(b.name));

            console.log(
              "france",
              this.countryList.filter(p => p.code === "FR")
            );
          }
        })
        .catch(err => console.error("Error fetching shipments", err));
    },
    toggleShipments() {
      this.showAllShipments = !this.showAllShipments;
    },
    toggleShips() {
      this.showAllShips = !this.showAllShips;
    },
    handleDragStart(event, shipment, from, ship = null) {
      this.draggingShipment = shipment;
      this.draggingFrom = from; // "unassigned" or "ship"
      this.draggingShip = ship;
      event.dataTransfer.effectAllowed = "move";
    },
    handleDrop(event, target, targetShip = null) {
      if (!this.draggingShipment) return;
      var that = this;
      var addToShip = function() {
        that.draggingShip.shipments = (that.draggingShip?.shipments || []).filter(
          s => s.shipment_id !== that.draggingShipment.shipment_id
        );
        // if (!that.draggingShip.shipments.length) {
        // that.draggingShip.shipments.push(that.draggingShipment)
        // }
        that.$set(that.draggingShip, "shipments", [...that.draggingShip.shipments]);
      };

      // --- Remove from origin ---
      if (this.draggingFrom === "unassigned") {
        // this.shipments = this.shipments.filter(
        //   (s) => s._id !== this.draggingShipment._id
        // );
        this.draggingShip = targetShip;
        addToShip();
      } else if (this.draggingFrom === "ship" && this.draggingShip) {
        addToShip();
      }

      // --- Add to target ---
      if (
        target === "ship" &&
        targetShip &&
        !(targetShip.shipments || []).some(s => String(s.shipment_id) === String(this.draggingShipment.shipment_id))
      ) {
        const updatedShipments = targetShip.shipments
          ? [...targetShip.shipments, this.draggingShipment]
          : [this.draggingShipment];
        this.$set(targetShip, "shipments", updatedShipments);
      } else if (target === "unassigned") {
        this.shipments = [...this.shipments, this.draggingShipment];
      } else {
        return;
      }

      // --- Force ships array refresh (for Vue 2 reactivity) ---
      this.ships = [...this.ships];

      // --- Reset drag state ---
      this.updateAssigment(targetShip);
      this.updateShip(this.draggingShip);

      this.draggingShipment = null;
      this.draggingFrom = null;
      this.draggingShip = null;
      // this.ship_key = !this.ship_key
      // this.shipment_key = !this.shipment_key
    },
    getColorClass(port) {
      return port?.color || "";
    },
    getUsedCapacity(ship) {
      var shipments = this.fullShipments(ship);
      // total in cubic feet
      const totalCF = Math.ceil((shipments || []).reduce((sum, s) => sum + (s.volume || 0), 0));

      // conversions
      ship.measurement_cf = totalCF;
      ship.measurement_cm = Math.ceil(totalCF * 0.0283168); // ft³ → m³

      ship.gross_weight_lb = Math.ceil(totalCF * 7); // 1 ft³ ≈ 7 lbs
      ship.gross_weight_kg = Math.ceil(ship.gross_weight_lb * 0.453592); // lbs → kg

      return ship.measurement_cm;
    },

    getCapacity(ship) {
      if (ship.container_size) {
        const sizes = {
          "20ft": 33.2, // 33.2 m³ → 33,200 liters (example)
          "40ft": 67.7,
          "40ft HC": 76.3,
          "45ft HC": 86.0
        };
        return sizes[ship.container_size] || ship.capacity || 1;
      }
      return ship.capacity || 1;
    },

    getPercent(ship) {
      const cap = this.getCapacity(ship);
      return Math.min((this.getUsedCapacity(ship) / cap) * 100, 100);
    }
  }
};
</script>
<style lang="css" scoped>
.container-progress .v-progress-linear__determinate {
  background-image: repeating-linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.3) 0,
    rgba(255, 255, 255, 0.3) 8px,
    transparent 8px,
    transparent 16px
  );
  background-size: 16px 100%;
}
</style>
